<template>
  <div :class="{
        'drag-and-drop': true,
        'drag-and-drop--hover': isHover
    }"
       @dragover="dragover"
       @dragleave="dragleave"
       @drop="drop">
    <input type="file"
           multiple
           class=""
           @change="onChange"
           ref="file"
           accept=".jpg,.jpeg,.png"/>
    <span>{{ placeholder }}</span>
  </div>
</template>

<script>
export default {
  name: 'DragAndDrop',
  props: {
    placeholder: {
      type: String,
      default: 'Drag and drop images...'
    }
  },
  data () {
    return {
      isDragOver: false,
      count: 0,
      filelist: []
    }
  },
  computed: {
    isHover () {
      return this.isDragOver
    }
  },
  created () {
    document.addEventListener('dragover', this.dragover)
    document.addEventListener('dragleave', this.dragleave)
    document.addEventListener('drop', this.drop)
  },
  methods: {
    async onChange () {
      this.filelist = [...this.$refs.file.files]
      this.$emit('change', this.filelist)
    },
    remove (i) {
      this.filelist.splice(i, 1)
    },
    dragover (event) {
      event.preventDefault()
      this.isDragOver = true
    },
    dragleave (event) {
      this.isDragOver = false
    },
    drop (event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange()
      this.isDragOver = false
    },
    select () {
      this.$refs.file.click()
    }
  },
  destroyed () {
    document.removeEventListener('dragover', this.dragover)
    document.removeEventListener('dragleave', this.dragleave)
    document.removeEventListener('drop', this.drop)
  }
}
</script>

<style scoped lang="scss">
.drag-and-drop {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 9999;
  background-color: #ffffffab;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  opacity: 0;
  transition: opacity .1s ease-in;

  input {
    display: none;
  }

  &--hover {
    opacity: 1;
  }
}
</style>
